import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import UsersTable from 'components/tables/UsersTable/UsersTable';
import VerificationCodesTable from 'components/tables/VerificationCodesTable/VerificationCodesTable';
import useGlobalStyles from 'styles/globalStyles';

export default function VerificationCodesPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Verification codes'}
            buttons={[
              // <CustomButton key='export' text='Export' color='primary' />
            ]}
          />
        </Box>

        <Box mt={3}>
          <VerificationCodesTable />
        </Box>
      </Container>
    </Box>
  )
}

